import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartRadial } from './useGetChartRadial'
import { ChartRadialContent } from './ChartRadialContent'

export const ChartRadialComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartRadial(id, tileFilterSelections)

  return (
    <ChartRadialContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartRadialComponentLoading() {
  return 'Loading...'
}
